import { useMutation } from "react-query";
import { getIdsForCarrierDownload } from "../../../../actions/CarrierAgreementMgmt/Carrier";

const useForCarrierDownload = () => {
  return useMutation(getIdsForCarrierDownload);
};
export default useForCarrierDownload;
